import template from './v2.html';
import controller from './v2.controller';

let v2Component = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default v2Component;



// WEBPACK FOOTER //
// ./client/app/components/v2/v2.component.js